import React, { useState, useEffect } from "react";
import { Button } from "../../../components/Button";
import exclamation from "../../../assets/images/SVG/credit.svg";
import ofvIcon from '../../../assets/images/SVG/Ofv-icon.svg'
import iconHumano from '../../../assets/images/SVG/Icon-humano-app.svg'
import { MENSAJES, URL_CANALES } from '../../../utils/Constants'


const ModalDomiciliacion = ({ onCancel }) => {

    const [validarSistema, setValidarSistema] = useState('')

    const validarSistemaOperativo = () => {
        var OSName = "Unknown OS";
        if (navigator.userAgent.indexOf("Win") !== -1) OSName = "Windows";
        if (navigator.userAgent.indexOf("Mac") !== -1) OSName = "Macintosh";
        if (navigator.userAgent.indexOf("Linux") !== -1) OSName = "Linux";
        if (navigator.userAgent.indexOf("Android") !== -1) OSName = "Android";
        if (navigator.userAgent.indexOf("like Mac") !== -1) OSName = "iOS";

        setValidarSistema(OSName);
    }

    useEffect(() => {
        validarSistemaOperativo()
    }, [validarSistema])

    const openInNewTab = pagina => {
        window.open(URL_CANALES[pagina], '_blank', 'noopener,noreferrer');
    };

    return (
        <div id="centeredModal" className="modal-wrapper modal-is-open">
            <div className="overlay"></div>
            <div className="modal modal-centered">
                <div className="modal-content rounded-lg bg-white p-10 flex flex-col w-2/3">
                    <div className="flex flex-col items-center justify-center">
                        <img src={exclamation} alt="Exclamation icon" className="w-1/3 h-24 w-24" />
                        <div className="text-primary text-opacity-700 text-3xl text-center mt-5 font-bold leading-none">
                            {MENSAJES.DOMICILIACION.TITULO}
                        </div>
                    </div>
                    <div className="flex flex-col items-center justify-start">
                        <p className="text-primary opacity-75 text-2xl text-center leading-none mt-5">
                            {MENSAJES.DOMICILIACION.DESCRIPCION}
                        </p>

                        <div className="flex flex-row">
                            <div className="flex flex-col justify-center items-center text-primary opacity-75 text-1xl leading-none m-5" onClick={() => openInNewTab("OFV")}>
                                <img src={ofvIcon} alt="Exclamation icon" width={71} height={71} />
                                <p className="text-center">
                                    {"Oficina Virtual"}
                                </p>
                            </div>
                            {validarSistema === "Android" && <div className="flex flex-col justify-center items-center text-primary opacity-75 text-1xl leading-none m-5" onClick={() => openInNewTab("APP_HUMANO_ANDROID")}>
                                <img src={iconHumano} alt="Exclamation icon" width={71} height={71} />
                                <p className="text-center">
                                    {"Humano App Android"}
                                </p>
                            </div>}
                            {validarSistema === "iOS" && <div className="flex flex-col justify-center items-center text-primary opacity-75 text-1xl leading-none m-5" onClick={() => openInNewTab("APP_HUMANO_IOS")}>
                                <img src={iconHumano} alt="Exclamation icon" width={71} height={71} />
                                <p className="text-center">
                                    {"Humano App iOS"}
                                </p>
                            </div>}
                        </div>

                    </div>
                    <div className="w-2/3 mx-auto mt-5 items-center justify-center">
                        <Button
                            className="btn btn-outline btn-xs btn-danger w-full mt-2"
                            onClick={onCancel}
                        >
                            <label className="flex flex-col text-center text-xl items-center">
                                Cancelar
                            </label>
                        </Button>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default ModalDomiciliacion;
